// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface CaptionParams {
  caption?: string;
  photoId: string;
}
interface DeleteParams {
  photoId: string;
}
interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Args {
  getParams: CaptionParams;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Args
>;

/**
 * Update caption of a floor plan photo
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_caption(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Args
>;

/**
 * Delete a photo of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_delete(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args
>;

/**
 * Upload a photo for a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
